exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".matchTitle[data-v-672e6542] {\n  font-size: 0.166667rem;\n  color: #5099fd;\n  text-align: center;\n  padding-bottom: 0.161458rem;\n  letter-spacing: 0.010417rem;\n}\n.registerForm[data-v-672e6542] {\n  padding: 0 0.15625rem;\n}\n.btnMode[data-v-672e6542] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.descInfo[data-v-672e6542] {\n  text-align: center;\n  font-size: 0.072917rem;\n  padding-bottom: 0.114583rem;\n  color: #f00;\n}", ""]);

// exports
